/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5% blocking buffer is 50 g of milk or BSA per litre of TBST.`)
};

const es_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El buffer de bloqueo al 5% son 50 g de leche o BSA por litro de TBST.`)
};

const de_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5%iger Blockierpuffer entspricht 50 g Milch oder BSA pro Liter TBST.`)
};

const nl_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5% blokkeerbuffer is 50 g melk of BSA per liter TBST.`)
};

const fr_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tampon de blocage à 5 % contient 50 g de lait ou de BSA par litre de TBST.`)
};

const it_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il buffer di blocco al 5% è 50 g di latte o BSA per litro di TBST.`)
};

const pt_br2_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tampão de bloqueio a 5% é 50 g de leite ou BSA por litro de TBST.`)
};

const pt_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tampão de bloqueio a 5% é 50 g de leite ou BSA por litro de TBST.`)
};

const ja_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5%ブロッキングバッファーは、TBST 1リットルあたりミルクまたはBSA 50gです。`)
};

const zh_buf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5% 封闭液为每升 TBST 中加入 50 g 脱脂奶或 BSA。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_ex3", locale)
	if (locale === "en") return en_buf_ex3(inputs)
	if (locale === "es") return es_buf_ex3(inputs)
	if (locale === "de") return de_buf_ex3(inputs)
	if (locale === "nl") return nl_buf_ex3(inputs)
	if (locale === "fr") return fr_buf_ex3(inputs)
	if (locale === "it") return it_buf_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_buf_ex3(inputs)
	if (locale === "pt") return pt_buf_ex3(inputs)
	if (locale === "ja") return ja_buf_ex3(inputs)
	return zh_buf_ex3(inputs)
};